var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"copyright-footer"},[_c('router-link',{attrs:{"to":{ name: 'service' }}},[_vm._v("Sharewind")]),_c('span',[_vm._v("Copyright © 2021 IWATSU ELECTRIC CO., LTD. All Rights Reserved.")])],1)}
var staticRenderFns = []

export { render, staticRenderFns }